const state = () => ({
  user: {
    chapterProgress: '',
    currentChapterProgress: 1
  },
  assessments: []
})

const getters = {
  getUser () {
    return state.user
  },

  getAssessmentProgress () {
    return state.assessments
  }
}

const mutations = {
  setUser: (state, user) => {
    state.user = user
  },
  SET_ASSESSMENT_PROGRESS: (state, payload) => {
    const { title, section, progress } = payload

    let isFound = false
    for (const assessment of state.assessments) {
      if (assessment.title === title && assessment.section === section) {
        assessment.progress = progress
        isFound = true
      }
    }

    if (!isFound) {
      state.assessments.push(payload)
    }
  }
}

const actions = {
  setUserProgress ({ commit }, user) {
    commit('setUser', user)
  },

  setAssessmentProgress ({ commit }, data) {
    commit('SET_ASSESSMENT_PROGRESS', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
